import { render, staticRenderFns } from "./infographic.vue?vue&type=template&id=2254dffa&scoped=true"
import script from "./infographic.vue?vue&type=script&lang=js"
export * from "./infographic.vue?vue&type=script&lang=js"
import style0 from "./infographic.vue?vue&type=style&index=0&id=2254dffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254dffa",
  null
  
)

export default component.exports